import { z } from 'zod';

/**
 * 支払 / 費用セクション共通の検索パラメータ。
 * 勤怠にもカタログ軸が無いため、集計軸は組織別 / 個人別の 2 つだけを取る。
 */
export const attendanceContractCostSearchSchema = z.object({
  comparisonTarget: z.enum(['PREVIOUS_YEAR', 'PREVIOUS_MONTH']).default('PREVIOUS_MONTH'),
  freeText: z.string().optional(),
  groupBy: z.enum(['department', 'member']).default('department'),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100)
});
export type AttendanceContractCostSearch = z.infer<typeof attendanceContractCostSearchSchema>;